var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a", { attrs: { href: _vm.orderUrl(_vm.mainOrderId) } }, [
        _vm._v(_vm._s(_vm.mainOrderId))
      ]),
      _vm._v(" "),
      _vm.additionalOrderIdsCount > 0
        ? _vm._l(_vm.additionalOrderIds, function(additionalOrderId, index) {
            return _c(
              "span",
              { key: index },
              [
                _c("a", { attrs: { href: _vm.orderUrl(additionalOrderId) } }, [
                  _vm._v(_vm._s(additionalOrderId))
                ]),
                _vm._v(" "),
                index + 1 !== _vm.additionalOrderIdsCount
                  ? [_vm._v(", ")]
                  : _vm._e()
              ],
              2
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdabea56", { render: render, staticRenderFns: staticRenderFns })
  }
}